
/* punchline text scroll effect */
document.addEventListener('DOMContentLoaded', function () {
  function wrapWordsInSpan() {
    const textElement = document.querySelector('.home__punchline .cell');
    if (!textElement) return;
  
    const text = textElement.textContent.trim();
    const words = text.split(' ').map((word) => `<span class="word">${word} </span>`).join(' ');
  
    textElement.innerHTML = words;
  }
  
  wrapWordsInSpan();
  
  const words = document.querySelectorAll('.home__punchline .word');
  
  function updateOpacity() {
    const viewportHeight = window.innerHeight;
  
    words.forEach((word) => {
      const rect = word.getBoundingClientRect();
      const wordPosition = rect.top; // Position du mot par rapport au viewport
  
      // Normaliser entre 0 et 1 en fonction de la position dans l'écran
      const progress = Math.min(Math.max((viewportHeight - wordPosition) / viewportHeight, 0), 1);
  
      // Appliquer des paliers : 25%, 50%, 100%
      let opacity;
      if (progress < 0.33) {
        opacity = 0.25;
      } else if (progress < 0.66) {
        opacity = 0.5;
      } else {
        opacity = 1;
      }
  
      word.style.opacity = opacity;
    });
  }
  
  window.addEventListener('scroll', updateOpacity);
  updateOpacity(); // Appel initial pour les mots déjà visibles
});
  